module.exports = require("draft-js");